import React from 'react'
import { Logo } from 'components'
import { bool } from 'prop-types'
import { connect } from 'react-redux'
import {
  GEORGE_TERMSCONDITIONS_URL,
  GROCERIES_TERMSCONDITIONS_URL,
  GEORGE_PRIVACYPOLICY_URL,
  GROCERIES_PRIVACYPOLICY_URL,
  GEORGE_CONTACTUS_URL,
  GROCERIES_CONTACTUS_URL,
} from 'services/utils/constants/site-urls'
// import arrow from './images/arrow.svg'
// import feedbackIcon from './images/feedback-icon.svg'

export const Footer = ({ isGeorgeUser }) => (
  <footer>
    <div className="footer-wrapper">
      <div className="footer-top">
        {/* <div className="back-top">
          <button className="back-top-link" onClick={() => window.scrollTo(0, 0)}>
            <span>BACK TO TOP</span>
            <img className="up-arrow" src={arrow} alt="arrow" />
          </button>
        </div>
        <a
          className="website-feedback-link"
          href="https://ghs-optin-issues.asda.com"
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => {
            if (window.opinionload) window.opinionload(e)
          }}
        >
          <img className="feedback-icon" src={feedbackIcon} alt="feedback icon" />
          <span>Website Feedback</span>
        </a> */}
      </div>
      <div className="footer-main">
        {isGeorgeUser ? <div className='footer-george-logo'>© George {new Date().getFullYear()}</div> :
        <div className="footer-logo">
          <Logo footer />
        </div>
        }
        <div className="footer-links">
          <ul>
            {!isGeorgeUser && <li>© ASDA {new Date().getFullYear()}</li>}
            <li>
              <a
                href={isGeorgeUser ? GEORGE_TERMSCONDITIONS_URL : GROCERIES_TERMSCONDITIONS_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms &amp; Conditions
              </a>
            </li>
            <li>
              <a
                href={isGeorgeUser ? GEORGE_PRIVACYPOLICY_URL : GROCERIES_PRIVACYPOLICY_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                {isGeorgeUser ? 'Privacy Policy' : 'Privacy Centre'}
              </a>
            </li>
            <li className={isGeorgeUser ? 'border-right' : null}>
              <a
                href={isGeorgeUser ? GEORGE_CONTACTUS_URL : GROCERIES_CONTACTUS_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                {isGeorgeUser ? 'Contact Us' : 'Asda Company Details'}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
)


Footer.propTypes = {
  isGeorgeUser: bool.isRequired,
}


const mapStateToProps = ({ ui }) => ({
  ...ui,
})

export default connect(mapStateToProps)(Footer)
